export default class NodePath {
  constructor(source, target) {
    this.source = source;
    this.target = target;
    this.firstNode = null;
  }
  find(bGreedy) {
    this.findByCompair(node => node[this.target.key] == this.target.value, bGreedy);
    return this;
  }
  findByCompair(fCompair, bGreedy) {
    bGreedy = bGreedy == undefined ? true : bGreedy;
    this.nodes = this.findNodes(this.source, fCompair, bGreedy);
    return this;
  }
  computeFirstNode() {
    this.nodes.forEach(n => (n.path = this.findPath(n, this.source)));
    const length = this.nodes.reduce((acc, node) => (node.path.tree.length > acc ? node.path.tree.length : acc), 0);
    const bigNumber = parseInt(
      Array(length)
        .fill('9')
        .join(''),
    );
    this.nodes.reduce((acc, node) => {
      const number = parseInt(node.path.tree.join('').padEnd(length, '0'));
      let min = 0;
      if (number < acc) {
        this.firstNode = node;
        min = number;
      } else {
        min = acc;
      }
      return min;
    }, bigNumber);
    return this;
  }
  findPath(node, nodes) {
    const group = [node];
    const tree = [];
    let item = node;
    while (item.parentId) {
      const parents = this.findNodes(nodes, node => node['id'] == item.parentId, false);
      group.unshift(parents[0]);
      tree.unshift(parents[0].children.findIndex(i => i.id == item.id));
      item = parents[0];
    }
    tree.unshift(nodes.findIndex(i => i.id == item.id));
    return { group, tree };
  }
  findNodes(aTree, fCompair, bGreedy) {
    var aInnerTree = []; // will contain the inner children
    var oNode; // always the current node
    var aReturnNodes = []; // the nodes array which will returned

    // 1. loop through all root nodes so we don't touch the tree structure
    for (let keysTree in aTree) {
      aInnerTree.push(aTree[keysTree]);
    }
    while (aInnerTree.length > 0) {
      oNode = aInnerTree.pop();
      // check current node
      if (fCompair(oNode)) {
        aReturnNodes.push(oNode);
        if (!bGreedy) {
          return aReturnNodes;
        }
      } else {
        // if (node.children && node.children.length) {
        // find other objects, 1. check all properties of the node if they are arrays
        for (let keysNode in oNode) {
          // true if the property is an array
          if (oNode[keysNode] instanceof Array) {
            // 2. push all array object to aInnerTree to search in those later
            for (var i = 0; i < oNode[keysNode].length; i++) {
              aInnerTree.push(oNode[keysNode][i]);
            }
          }
        }
      }
    }
    return aReturnNodes; // someone was greedy
  }
}
